<template>
  <div>
    <v-container
      class="no--vertical--paddings"
      fluid
      >
      <v-row
        no-gutters
        justify=center>
        <v-col
          md=9
          sm=12
          cols=12>
          <v-search-box
            v-model="conditions"
            @search-button-click="search"
            />
        </v-col>
      </v-row>
      <Loading
        v-if="isLoading"/>
      <v-row
        justify=center
        no-gutters
        v-else
        >
        <v-col md=9 sm=12 cols=12>
          <v-container
            fluid
            v-if="!teachers.length()"
            class="no--vertical--paddings">
            <v-card
              class="main--text"
              >
              <v-container>
                <v-row
                  dense>
                  <v-col>
                    <span style="font-size:1.1rem">
                    該当する先生は見つかりませんでした。
                    </span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-container>
          <v-container
            fluid
            v-else
            class="no--vertical--paddings">
            <v-row
              dense
              justify=start>
              <v-col
                v-for="teacher in teachers.get()"
                :key=teacher.uuid
                md=4
                sm=6
                cols=12>
                <v-searched-teacher-card
                  :teacher="teacher"
                  @info-button-click="displayProfile(teacher)"
                  @request-button-click="displayRequest(teacher)"/>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid>
      <v-searched-teacher-profile-dialog
        v-if="teacher"
        :enable="teacherDialog"
        :teacher="teacher"
        @request-button-click="displayRequest"
        @close-button-click="closeProfile"/>
      </v-container>
    <v-container
      fluid>
      <v-select-students-for-request
        v-if="teacher"
        :enable="requestDialog"
        :teacher="teacher"
        @send-button-click="sendRequests"
        @close-button-click="requestDialog=false"/>
    </v-container>
  </div>
</template>

<script>
import VSearchedTeacherCard from "@/components/organisms/parent/VSearchedTeacherCard.vue"
import VSearchedTeacherProfileDialog from "@/components/organisms/parent/VSearchedTeacherProfileDialog.vue"
import VSearchBox from "@/components/organisms/parent/VSearchBox.vue"
import VSelectStudentsForRequest from "@/components/organisms/parent/VSelectStudentsForRequest.vue"
import { TeacherRepository } from "@/repository/TeacherRepository.js"
import { RequestRepository } from "@/repository/RequestRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import Loading from "@/components/organisms/Loading.vue"

export default {
  components: {
    VSearchedTeacherCard,
    VSearchedTeacherProfileDialog,
    VSearchBox,
    VSelectStudentsForRequest,
    Loading
  },
  data() {
    return {
      teachers: null,
      allTeachers: null,
      isLoading: true,
      conditions: {
        gender: false,
        prefecture: false,
        availableDays: ["月", "火", "水", "木", "金", "土", "日"]
      },
      teacherDialog: false,
      teacher: null,
      requestDialog: false
    }
  },
  methods: {
    search: function () {
      this.isLoading = true
      this.teachers = this.allTeachers.filterByConditions(this.conditions)
      this.isLoading = false
    },
    displayProfile: function (teacher) {
      this.teacher = teacher
      this.teacherDialog = true
    },
    closeProfile: function () {
      this.teacherDialog = false
      this.teacher = null
    },
    displayRequest: function (teacher) {
      this.teacher = teacher
      this.requestDialog = true
      this.teacherDialog = false
    },
    sendRequests: async function (teacher, studentIds) {
      const requestRepo = new RequestRepository(firestore)
      const requests = await requestRepo.createAtOnce(teacher.uuid, this.$store.getters.parent.uuid, studentIds)
      this.requestDialog = false
    }
  },
  created: async function () {
    this.teacherRepo = new TeacherRepository(firestore)
    this.allTeachers = await this.teacherRepo.list()
    this.teachers = this.allTeachers
    this.isLoading = false
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>